export const DASHBOARD_QUERY_KEYS = {
	all: ["dashboard"] as const,
	data: (range: string, moneda: string, propiedadIds: number[] = []) =>
		[
			...DASHBOARD_QUERY_KEYS.all,
			range,
			moneda,
			[...propiedadIds].sort((a, b) => a - b).join(","),
		] as const,
};
